import { useIndexerQuery } from "@/shared/indexer/useIndexerQuery"
import { Sale } from "../types"

export function useSales() {
  return useIndexerQuery<Sale[]>({
    commandName: "marketplaceSales",
    select: (data: any) => data?.data.MarketplaceSale || [],
  })
}
